import { put2 } from "@/shared/axios";
import useAccountQuery from "@/shared/hooks/useAccountQuery";
import useIsSuperAdmin from "@/shared/hooks/useIsSuperAdmin";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface OnboardingMutationBody {
  status: number;
  message: string;
  item_id: number;
  branch_id: number;
}

const useOnboardingMutation = () => {
  const isSuperAdmin = useIsSuperAdmin();
  const queryClient = useQueryClient();
  const { data: account } = useAccountQuery();
  return useMutation({
    mutationFn: (data: OnboardingMutationBody) =>
      put2(
        `/internal/secure/pos/v1/edit/activation/activities/${data.branch_id}/${data.item_id}/${account.item_id}`,
        {
          status: data.status,
          message: data.message,
        }
      ),
    onSuccess: (_, variables) => {
      const queryKey = isSuperAdmin
        ? [variables?.branch_id, "admin", "onboarding"]
        : [variables?.branch_id, "onboarding"];
      queryClient.refetchQueries({ queryKey, exact: true });
    },
  });
};

export default useOnboardingMutation;
